import * as types from "../constants/ActionTypes";

const open = () => ({ type: types.PASSWORD_FORM_OPEN });
const close = () => ({ type: types.PASSWORD_FORM_CLOSE });

const changeField = (field, value) => ({
  type: types.PASSWORD_FORM_CHANGE_FIELD,
  field,
  value
});

const submit = () => ({ type: types.PASSWORD_FORM_WILL_SUBMIT });

const submitSuccess = data => ({ type: types.PASSWORD_FORM_DID_SUBMIT, data });

const submitFailure = error => ({
  type: types.PASSWORD_FORM_DID_SUBMIT_FAILED,
  error
});

export { open, close, changeField, submit, submitSuccess, submitFailure };
